import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { Placeholder } from '../common/Placeholders.jsx';
import { placeholderAmount } from '../../../config';

import { getCoupons } from '../../actions/coupons';
import CouponsItem from './CouponsItem.jsx';

class Coupons extends React.Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
  };

  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.props.getCoupons().then(() => this.setState({ isLoading: false }));
  }

  render() {
    let items = [];
    if (this.state.isLoading) {
        for (let i = 0; i < placeholderAmount; i++){
          items.push(<Placeholder/>);
        }
    } else {
      if (this.props.list.length) {
        items = this.props.list.map(coupon => <CouponsItem key={ coupon.id } { ...coupon }/>);
      } else {
        items = <p>{ gettext('Ваш список промокодов пуст') }</p>
      }
    }

    return <div>{ items }</div>
  }
};


let mapStateToProps = (state) => {
  return {
    list: state.coupons.list,
  }
};

export default compose(
  connect(mapStateToProps, { getCoupons }),
  LoginRequired,
  Page
)(Coupons);